import React from 'react'

export default function contact() {
  return (
    <div className='container'> <h1>Contact us</h1>
    why should u contact us? 🤔</div>
  )
}
